import { useContext } from 'react';
import InputFile from "../controls/InputFile";
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';


const StepAutoUsado = () => {

    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorCRDataContext);

    const { auFilesUsado } = poliza;

    const onChangeFiles = (id, newFile) => {
        const { auFilesUsado } = poliza;
        if (!id.startsWith('file') || id.length <= 4)
            return;
        let index = id.substring(4);
        auFilesUsado[index] = newFile;
        setPoliza({ ...poliza, auFilesUsado });
    }



    return (
        <>

            <div className='reponsive'>
                <div className="reponsive-width-12 box-pl5-pr5 lfheader">
                    <label>Vehículo Usado</label>
                </div>
                <div className="reponsive-width-6">
                    <div className="box-pl5-pr5">
                        <InputFile
                            id="file0"
                            label='Favor adjuntar fotos de para choques delantero'
                            handlerFiles={onChangeFiles}
                            file={auFilesUsado[0]}
                        />
                        <InputFile
                            id="file1"
                            label='Favor adjuntar fotos de para choques trasero'
                            handlerFiles={onChangeFiles}
                            file={auFilesUsado[1]}
                        />
                    </div>
                </div>
                <div className="reponsive-width-6">
                    <div className="box-pl5-pr5">
                        <InputFile
                            id="file2"
                            label='Favor adjuntar fotos laterales derecho'
                            handlerFiles={onChangeFiles}
                            file={auFilesUsado[2]}
                        />
                        <InputFile
                            id="file3"
                            label='Favor adjuntar fotos laterales izquierdo'
                            handlerFiles={onChangeFiles}
                            file={auFilesUsado[3]}
                        />
                    </div>
                </div>
                <div className="reponsive-width-12 box-pl5-pr5">
                    <InputFile
                        id="file4"
                        label='Favor adjuntar fotos panel encendido'
                        handlerFiles={onChangeFiles} part=''
                        file={auFilesUsado[4]}
                    />

                </div>
            </div>
        </>

    )
}

export default StepAutoUsado; 